import React from "react";

const ThemeContext = React.createContext({
  theme: 'default',
  switchTheme: () => {},
});

export default ThemeContext;